"use client";

import { useState } from "react";
import Link from "next/link";
import { ChevronDown, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import LoyaltyCard from "@/components/LoyaltyCard";
import { registrationDefaultValues, REWARD_EMOJIS } from "@/lib/constants";

export default function HeroCardPlayground() {
  const [name, setName] = useState("Morning Brew");
  const [description, setDescription] = useState("Free Item");
  const [rewardEmoji, setRewardEmoji] = useState("☕");

  return (
    <div className="w-full max-w-sm space-y-4">
      <div className="w-full max-w-xs rounded-2xl overflow-hidden shadow-xl mx-auto dark:border dark:border-white/15">
        <LoyaltyCard
          name={name || "Your venue"}
          background={registrationDefaultValues.card.background}
          color={registrationDefaultValues.card.color}
          pictureSrc={registrationDefaultValues.venue.picture}
          description={description ?? "Free Coffee"}
          pointsRequired={9}
          rewardEmoji={rewardEmoji}
          pointsCollected={5}
        />
      </div>

      <div className="space-y-2">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">
          Make it yours
        </p>
        <div className="relative">
          <Input
            placeholder="Venue name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={30}
            className="text-center"
          />
          {name && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              aria-label="Clear venue name"
              className="absolute value right-1 top-1/2 -translate-y-1/2 h-6 w-6 rounded-full text-muted-foreground hover:text-foreground cursor-pointer"
              onClick={() => setName("")}
            >
              <X className="size-3.5" />
            </Button>
          )}
        </div>

        <div className="grid grid-cols-2 gap-2">
          <Input
            placeholder="Reward"
            onChange={(e) => setDescription(e.target.value)}
          />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button type="button" variant="outline">
                <span>{rewardEmoji}</span>
                <span>Icon</span>
                <ChevronDown className="h-4 w-4 ml-auto opacity-50" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="center"
              className="grid grid-cols-4 gap-1 p-2"
            >
              {REWARD_EMOJIS.map((emoji) => (
                <DropdownMenuItem
                  key={emoji}
                  className="text-2xl justify-center cursor-pointer focus:bg-brand-purple/10"
                  onSelect={() => setRewardEmoji(emoji)}
                >
                  {emoji}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        {!name && (
          <p className="text-sm text-red-500">Please, enter your venue name</p>
        )}
      </div>

      <div className="flex flex-col gap-3 w-full pt-2">
        {name === "" ? (
          <Button size="lg" className="w-full" disabled>
            Create your loyalty card
          </Button>
        ) : (
          <Button asChild size="lg" className="w-full">
            <Link
              href={{
                pathname: "/new-venue",
                query: { name, emoji: rewardEmoji, description },
              }}
            >
              Create your loyalty card
            </Link>
          </Button>
        )}

        <p className="text-xs text-muted-foreground">
          Already have an account?{" "}
          <Link
            href="/sign-in"
            className="underline underline-offset-4 hover:text-foreground transition-colors"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
